<template>
  <v-col
    cols="12"
    md="9"
    :class="loadingPage ? 'text-center': ''"
  >
    <v-progress-circular
      v-if="loadingPage"
      color="primary"
      indeterminate
      class="mt-12 mx-a"
      :size="70"
    />
    <div
      v-else
      :class="$vuetify.breakpoint.mdAndUp ? 'desktop' : 'mobile'"
      class="chat-container elevation-3 pt-5 rounded"
    >
      <div class="chat-conversa px-7 mb-6">
        <p
          v-if="dataInicial"
          class="caption primary--text mb-0 pb-9 text-center"
        >
          {{ dataInicial }}
        </p>

        <div>
          <div
            v-for="(mensagem, index) in mensagensAgrupadas"
            :key="index"
            :class="mensagem.sender === idUsuario ? 'comprador' : 'produtor'"
            class="chat-conversa__item"
          >
            <p
              :class="[
                mensagem.sender !== idUsuario ? '' : 'primary white--text',
                $vuetify.breakpoint.mdAndUp ? 'desktop' : 'mobile'
              ]"
              class="chat-conversa__balao body-2 mb-1 pl-2 pr-3 py-2 rounded"
            >
              {{ mensagem.content.body }}
            </p>
            <p
              v-if="mensagem.origin_server_ts"
              class="chat-conversa__data caption mb-5 primary--text"
            >
              {{ formataData(mensagem.origin_server_ts) }}
            </p>
          </div>
        </div>
        <div class="chat-conversa__fim" />
      </div>
      <div class="chat-enviar pa-3">
        <v-form class="d-flex align-center">
          <v-textarea
            ref="inputSend"
            v-model="textoInput"
            background-color="white"
            class="mb-0"
            label="Digite sua mensagem"
            filled
            single-line
            rows="1"
            no-resize
            :disabled="loadingBtn"
            :loading="loadingBtn"
            @keydown="adicionaMensagemInput($event)"
          />
          <v-btn
            ref="btnSend"
            class="ml-2"
            color="primary"
            :fab="$vuetify.breakpoint.smAndDown"
            :loading="loadingBtn"
            :small="$vuetify.breakpoint.smAndDown"
            @click="adicionaMensagem()"
          >
            <v-icon v-if="$vuetify.breakpoint.smAndDown">
              fas fa-arrow-up
            </v-icon>

            <template v-if="$vuetify.breakpoint.mdAndUp">
              Enviar
            </template>
          </v-btn>
        </v-form>
      </div>
    </div>
    <ModalResposta
      titulo="Erro"
      :dialog="erro"
    >
      <template v-slot:texto>
        Desculpe, ocorreu um erro. Por favor, tente novamente mais tarde.
      </template>
    </ModalResposta>
  </v-col>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import ApiChat from '@/api/chat';
import ModalResposta from '@/components/ModalResposta.vue';
import matrixApi from '@/matrixApi';

export default {
  name: 'ChatMensagens',

  components: {
    ModalResposta,
  },

  data() {
    return {
      idUsuario: '',
      conversa: [],
      loadingPage: true,
      loadingBtn: false,
      textoInput: '',
      erro: false,
      idSala: '',
      idUltimoEvento: '',
      next_batch: '',
    };
  },

  computed: {
    ...mapState(['dadosTransacao']),

    dataInicial() {
      if (this.conversa.length > 0) {
        return this.formataData(this.conversa[0].origin_server_ts);
      }
      return '';
    },

    mensagensAgrupadas() {
      return this.conversa.map((mensagem, indice, mensagens) => {
        if (indice === mensagens.length - 1) {
          return mensagem;
        }

        const proximaMensagem = mensagens[indice + 1];
        const dataHora = this.formataData(mensagem.origin_server_ts);
        const proximaDataHora = this.formataData(proximaMensagem.origin_server_ts);
        if (mensagem.sender === proximaMensagem.sender && dataHora === proximaDataHora) {
          return {
            ...mensagem,
            origin_server_ts: null,
          };
        }

        return mensagem;
      });
    },
  },

  async mounted() {
    await this.carregaDadosSala();
    await this.verificaExisteConversa();
    setInterval(async () => {
      const route = this.next_batch === '' ? 'sync' : `sync?since=${this.next_batch}`;

      await matrixApi.get(route)
        .then(({ data }) => {
          this.next_batch = data.next_batch;
          const room = data.rooms && data.rooms.join && data.rooms.join[this.idSala];

          if (!room) {
            return;
          }

          if (room.unread_notifications.notification_count > 0) {
            this.verificaExisteConversa();
          }
        });
    }, 3000);
    await this.marcaTodasMensagensLidas();
  },

  methods: {
    async adicionaMensagem() {
      if (this.textoInput) {
        try {
          this.loadingBtn = true;
          await ApiChat.sendMessage(this.dadosTransacao.id, this.textoInput);
          const data = new Date();
          const mensagem = {
            content: {
              body: this.textoInput,
            },
            origin_server_ts: data.getTime(),
            sender: this.idUsuario,
          };
          this.conversa.push(mensagem);
          this.loadingBtn = false;

          this.$refs.inputSend.reset();
          setTimeout(() => { this.$refs.inputSend.focus(); }, 100);
          this.scrollConversa();

          await this.marcaTodasMensagensLidas();
        } catch (e) {
          this.erro = true;
        }
      }
    },

    async adicionaMensagemInput(event) {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        await this.adicionaMensagem();
      }
    },

    formataData(data) {
      const date = new Date(parseInt(data, 10));
      return moment(date).format('DD/MM/YY, kk:mm');
    },

    scrollConversa() {
      this.$nextTick(() => {
        const fimConversa = document.querySelector('.chat-conversa__fim');
        if (fimConversa) {
          const final = fimConversa.offsetTop;
          document.querySelector('.chat-conversa').scrollTop = final;
        }
      });
    },

    trataUsuarioMensagem(texto) {
      const numberPattern = /\d+/g;
      return Number(texto.match(numberPattern).join([]));
    },

    async verificaExisteConversa() {
      const conversaRecebida = await this.buscaMensagens();
      if (conversaRecebida.length > 0) {
        this.idUltimoEvento = conversaRecebida.at(-1).event_id;
      }
      this.conversa = conversaRecebida;
      this.scrollConversa();
    },

    async carregaDadosSala() {
      try {
        const response = await ApiChat.openRoom(this.dadosTransacao.id);
        this.idSala = response.data.roomId;
        this.idUsuario = this.trataUsuarioMensagem(response.data.userId);
      } catch (e) {
        this.erro = true;
        this.loadingPage = false;
      }
    },

    async buscaMensagens(event = '', messages = []) {
      const allMessages = messages;
      const limitEvents = 100;
      try {
        const response = await matrixApi.get(`rooms/${this.idSala}/messages`, {
          params: {
            from: event,
            dir: 'b',
            limit: limitEvents,
          },
        });
        const contextMessages = response.data.chunk.filter(e => e.type === 'm.room.message');
        contextMessages.forEach((item) => {
          const message = {
            content: {
              body: item.content.body,
            },
            event_id: item.event_id,
            origin_server_ts: item.origin_server_ts,
            sender: this.trataUsuarioMensagem(item.sender),
          };
          allMessages.push(message);
        });
        if (response.data.end !== response.data.start) {
          await this.buscaMensagens(response.data.end, allMessages);
        }
      } catch (e) {
        this.erro = true;
      }
      allMessages.sort((a, b) => a.origin_server_ts - b.origin_server_ts);
      this.loadingPage = false;

      return allMessages;
    },

    async marcaTodasMensagensLidas() {
      await matrixApi.post(`rooms/${this.idSala}/receipt/m.read/${this.idUltimoEvento}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-container {
  background: white;
  height: calc(100vh - 210px);
  min-height: 275px;

  &.desktop { height: calc(100vh - 144px); }
}
.chat-conversa {
  height: calc(100% - 104px);
  overflow: auto;

  &__item {
    display: flex;
    flex-direction: column;

    &.comprador { align-items: flex-end; }
    &.produtor { align-items: flex-start; }
  }

  &__balao {
    border: 1px solid #BABABA;
    max-width: 90%;

    &.desktop { max-width: 50%; }
  }
  .fim-mensagens {
    height: 1px;
  }
}
.chat-enviar {
  background: #D3D4D3;
}
</style>
<style lang="scss">
.chat-enviar {
  .v-text-field__details { display: none !important; }
  .v-input__slot { margin-bottom: 0; }
}
</style>
